/**
 * A faixa "DEV" — o painel e o app dizendo, no celular, que isto NÃO é o
 * sistema de verdade.
 *
 * ⚠️ Nasceu com o ambiente dev (24/09/2026, `docs/PLANO-AMBIENTE-DEV.md`):
 * dev.cerchia.com.br e painel.cerchia.com.br têm a mesma cara, e o Felipe vai
 * alternar entre os dois no mesmo telefone. Desmarcar um horário achando que é
 * teste, na aba de produção, é o erro que esta faixa existe para impedir.
 *
 * DOM puro, fora do React, montada pelo `main.tsx` de cada build: assim nenhuma
 * tela precisa saber que ela existe, e o `App` não muda. Pergunta ao servidor
 * (`/api/ambiente`) em vez de ler do build, porque o MESMO build sobe nos dois
 * ambientes — quem sabe onde está é o processo.
 *
 * Falhou a pergunta: nada aparece. É o lado seguro — produção sem faixa é o
 * normal, e uma faixa errada em produção assustaria o lojista.
 */
export function mostrarFaixaDoAmbiente(): void {
  void fetch('/api/ambiente')
    .then((r) => (r.ok ? (r.json() as Promise<{ ambiente?: string }>) : null))
    .then((r) => {
      if (r?.ambiente !== 'dev') return;
      document.title = `[DEV] ${document.title}`;

      const faixa = document.createElement('div');
      faixa.setAttribute('role', 'note');
      faixa.textContent = 'DEV · banco de teste';
      /* Inline, e não CSS: os dois builds têm folhas diferentes, e isto não
         pode depender de nenhuma delas carregar. Embaixo à esquerda e sem
         receber clique — o topo é do aviso flutuante (`Recado`), e a faixa não
         pode cobrir botão nenhum. */
      Object.assign(faixa.style, {
        position: 'fixed',
        left: '8px',
        bottom: '8px',
        zIndex: '9999',
        padding: '3px 9px',
        borderRadius: '999px',
        background: '#b4231c',
        color: '#fff',
        font: '600 11px/1.4 system-ui, sans-serif',
        letterSpacing: '0.04em',
        pointerEvents: 'none',
        opacity: '0.92',
      } satisfies Partial<CSSStyleDeclaration>);
      document.body.appendChild(faixa);

      /* Uma borda no topo também: a pílula pode ficar atrás do teclado do
         celular, a borda não. Elemento próprio, e não sombra no <html>, que o
         fundo do <body> pode cobrir. */
      const borda = document.createElement('div');
      Object.assign(borda.style, {
        position: 'fixed',
        top: '0',
        left: '0',
        right: '0',
        height: '3px',
        zIndex: '9999',
        background: '#b4231c',
        pointerEvents: 'none',
      } satisfies Partial<CSSStyleDeclaration>);
      document.body.appendChild(borda);
    })
    .catch(() => {});
}
